import { Col, Form, type FormItemProps, Input } from "antd"
import React, { type Dispatch, type SetStateAction } from "react"
import { type FormActiveElementInterface, type FormCategoryEnum, type FormInputElementInterface } from "~Components/form/form.types"
import { blurInputOnWeel } from "~Shared/utils/helper.utils"

interface FormInputElemProps {
    elem: FormInputElementInterface
    span?: number
    md?: number | object
    sm?: number | object
    activeCategory?: FormActiveElementInterface
    setActiveCategory?: Dispatch<SetStateAction<FormActiveElementInterface>>
    category?: FormCategoryEnum
    normalize?: FormItemProps["normalize"]
}

export const FormInputElem = ({ activeCategory, setActiveCategory, category, normalize, elem, ...columnProps }: FormInputElemProps) => {
    const { label, name, initialValue, rules, placeholder, onChange, onBlur, key, inputType = "text", isDisabled = false } = elem
    const isFilterActive = category && activeCategory && activeCategory[category]
    return (
        <Col {...columnProps}>
            <Form.Item
                label={label}
                name={name}
                key={key || name}
                initialValue={initialValue}
                rules={rules}
                style={{ marginBottom: "0px" }}
                className={isFilterActive ? "filter--active" : ""}
                normalize={normalize}
            >
                <Input
                    name={name}
                    type={inputType}
                    placeholder={placeholder}
                    onChange={(e) => {
                        if (category && setActiveCategory) {
                            setActiveCategory({ ...activeCategory, [category]: !!e.target.value })
                        }
                        if (onChange) {
                            onChange(e)
                        }
                    }}
                    onBlur={onBlur}
                    onWheel={blurInputOnWeel}
                    disabled={isDisabled}
                />
            </Form.Item>
        </Col>
    )
}
